import { Text } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { InViewAutoplayingYoutubeVideo } from './InViewAutoplayingYoutubeVideo'

export const YoungWashingtonBehindTheCamera = () => {
  const { t } = useTranslate('pif')

  return (
    <div className="my-[56px] flex flex-col px-4 md:my-[64px]">
      <Text className="photon-heading-xs md:photon-heading-sm tracking-tight" color="core-gray-950" weight="bold">
        {t('behindTheCameraWithJonErwin', 'Behind the Camera With Jon Erwin')}
      </Text>

      <Text className="photon-paragraph-sm md:photon-paragraph-md mt-3" color="core-gray-700">
        {t(
          'behindTheCameraWithJonErwinDescription',
          'Discover why this story matters. Pay it Forward today and get insider access to Jon Erwin\u2019s Director\u2019s Diaries, including this first look at his passion for bringing Young Washington to life.',
        )}
      </Text>

      <InViewAutoplayingYoutubeVideo
        className="mt-6 w-full overflow-hidden rounded-2xl"
        youtubeEmbedUrl="https://www.youtube.com/embed/1Y4Rvpv6mbU?mute=1&autoplay=0&enablejsapi=1&rel=0&playsinline=1"
        thumbnailUrl="/v1770831396/theatrical/young%20washington/jon-erwin-bts-vid-img-01"
        title={t('behindTheCameraWithJonErwin', 'Behind the Camera With Jon Erwin')}
      />
    </div>
  )
}
